<craft-icon class="svg-icon icon-search" name="search--search"></craft-icon>
<input
  type="text"
  [disabled]="disabled"
  [attr.maxlength]="maxlength"
  [placeholder]="placeholder"
  [value]="value"
  (blur)="onTouched()"
  (keydown.enter)="blurInput($event.target)"
  (input)="onInput($event.target)"
  class="input-search"
/>

<button *ngIf="!!value" type="button" (click)="clearClick()" matTooltip="Clear search" matTooltipPosition="above" class="btn btn-clear">
  <craft-icon class="svg-icon text-size-9" name="general--close-sm"></craft-icon>
</button>
